export class DoctorRegister {
    firstName: string;
    lastName: string;
    qualification: string;
    keySkills: string;
    emailId: string;
    mobileNumber: string;
    address: string;
    subordinateFlag: boolean;
    profileImageUrl: string;
    clinic: {
        clinicName: string;
        clinicContactNumber: string;
    };
}
